import { render } from "./ClassGrowthRecord.vue?vue&type=template&id=64cbfb92&scoped=true&ts=true"
import script from "./ClassGrowthRecord.vue?vue&type=script&lang=ts"
export * from "./ClassGrowthRecord.vue?vue&type=script&lang=ts"

import "./ClassGrowthRecord.vue?vue&type=style&index=0&id=64cbfb92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cbfb92"]])

export default __exports__